export const skillsData = [
  {
    id: 1,
    skillName: "HTML",
    value: 90
  },
  {
    id: 2,
    skillName: "CSS",
    value: 90
  },
  {
    id: 3,
    skillName: "JavaScript",
    value: 80
  },
  {
    id: 5,
    skillName: "Bootstrap",
    value: 85
  },
  {
    id: 6,
    skillName: "React JS",
    value: 85
  },
  {
    id: 7,
    skillName: "Gatsby JS",
    value: 80
  },
  {
    id: 8,
    skillName: "Strapi CMS",
    value: 80
  },
  {
    id: 9,
    skillName: "Graphql",
    value: 75
  },
  {
    id: 10,
    skillName: "PostgreSQL",
    value: 75
  },
  {
    id: 11,
    skillName: "Git",
    value: 90
  },
];

// AVAILABLE SKILLS

/* 
    HTML
    CSS
    JS 
    React
    Next JS
    Nuxt JS
    Node JS
    Vue
    Angular
    Docker
    Photoshop
    Illustrator
    Svelte
    GCP
    Azure
    Fastify
    Haxe
    Ionic
    Markdown
    Microsoft Office
    Picsart
    Sketch
    Unity
    WolframAlpha
    Adobe XD
    After Effects
    Bootstrap
    Bulma
    CapacitorJs
    Coffeescript
    MemSQL
    C
    C++
    C#
    Python
    Java
    Julia
    Matlab
    Swift
    Ruby
    Kotlin
    Go
    PHP
    Flutter
    Dart
    Typescript
    Swift
    Git
    Figma
    Canva
    Ubuntu
    Bootstrap
    MongoDB
    Tailwind
    ViteJS
    VuetifyJS
    MySQL
    PostgreSQL
    AWS
    Firebase
    Blender
    Premiere Pro
    Adobe Audition
    Deno
    Django
    Gimp
    Graphql
    Lightroom
    MaterialUI
    Nginx
    Numpy
    OpenCV
    Pytorch
    Selenium
    Strapi
    Tensorflow
    Webex
    Wordpress
*/
